(function () {
  'use strict';

  function animateCounters() {
    var counters = document.querySelectorAll('[data-sa-counter]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.dataset.saAnimated) return;
        el.dataset.saAnimated = '1';
        var target = parseInt(el.dataset.saCounter, 10);
        var prefix = el.dataset.saPrefix || '';
        var suffix = el.dataset.saSuffix || '';
        var duration = 1200;
        var start = performance.now();

        function step(now) {
          var elapsed = now - start;
          var progress = Math.min(elapsed / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = Math.round(target * eased);
          el.textContent = prefix + current + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.3 });

    counters.forEach(function (c) { observer.observe(c); });
  }

  function initReveal() {
    var els = document.querySelectorAll('.sa-reveal');
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sa-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    els.forEach(function (el) { observer.observe(el); });
  }

  function initButtonGroups() {
    document.querySelectorAll('.sa-form__btn-group').forEach(function (group) {
      var buttons = group.querySelectorAll('.sa-form__btn-option');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
        });
      });
    });
  }

  function validateField(input) {
    var group = input.closest('.sa-form__group');
    if (!group) return true;
    var errorEl = group.querySelector('.sa-form__error');
    var isValid = true;

    if (input.required && !input.value.trim()) {
      isValid = false;
    } else if (input.type === 'email' && input.value.trim()) {
      isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
    }

    if (!isValid) {
      input.classList.add('sa-form__input--error');
      if (errorEl) errorEl.classList.add('sa-form__error--visible');
    } else {
      input.classList.remove('sa-form__input--error');
      if (errorEl) errorEl.classList.remove('sa-form__error--visible');
    }

    return isValid;
  }

  function validateForm(form) {
    var inputs = form.querySelectorAll('[data-sa-validate]');
    var valid = true;
    inputs.forEach(function (input) {
      if (!validateField(input)) valid = false;
    });
    return valid;
  }

  /**
   * Google Sheets via Apps Script web app.
   * POST JSON to the script URL — it appends a row to the Sheet.
   */
  function submitToGoogleSheets(form) {
    var wrapper = form.closest('.sa-form-wrapper');
    var submitBtn = form.querySelector('.sa-form__submit');
    var apiError = form.querySelector('.sa-form__api-error');
    var successEl = wrapper ? wrapper.querySelector('.sa-success') : null;
    var sheetUrl = form.dataset.sheetUrl;

    if (!sheetUrl) {
      showApiError(apiError, 'Configuration error. Please contact support.');
      return;
    }

    var firstName = (form.querySelector('[name="first_name"]') || {}).value || '';
    var lastName = (form.querySelector('[name="last_name"]') || {}).value || '';
    var email = (form.querySelector('[name="email"]') || {}).value || '';
    var phone = (form.querySelector('[name="phone"]') || {}).value || '';

    var kitBtn = form.querySelector('.sa-form__btn-option[aria-pressed="true"]');
    var kitInterest = kitBtn ? kitBtn.dataset.value : '';

    var useCaseEl = form.querySelector('[name="use_case"]');
    var useCase = useCaseEl ? useCaseEl.value : '';

    submitBtn.disabled = true;
    submitBtn.classList.add('sa-form__submit--loading');
    hideApiError(apiError);

    var payload = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone: phone,
      starlink_kit: kitInterest,
      use_case: useCase
    };

    var formData = new FormData();
    formData.append('first_name', payload.first_name);
    formData.append('last_name', payload.last_name);
    formData.append('email', payload.email);
    formData.append('phone', payload.phone);
    formData.append('starlink_kit', payload.starlink_kit);
    formData.append('use_case', payload.use_case);

    fetch(sheetUrl, {
      method: 'POST',
      mode: 'no-cors',
      body: formData
    })
    .then(function () {
      form.style.display = 'none';
      if (successEl) successEl.classList.add('sa-success--visible');
    })
    .catch(function (err) {
      showApiError(apiError, err.message || 'Something went wrong. Please try again.');
    })
    .finally(function () {
      submitBtn.disabled = false;
      submitBtn.classList.remove('sa-form__submit--loading');
    });
  }

  function showApiError(el, msg) {
    if (!el) return;
    el.textContent = msg;
    el.classList.add('sa-form__api-error--visible');
  }

  function hideApiError(el) {
    if (!el) return;
    el.textContent = '';
    el.classList.remove('sa-form__api-error--visible');
  }

  function initForm() {
    var form = document.getElementById('sa-form');
    if (!form) return;

    form.querySelectorAll('[data-sa-validate]').forEach(function (input) {
      input.addEventListener('blur', function () { validateField(input); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validateForm(form)) return;
      submitToGoogleSheets(form);
    });
  }

  function init() {
    animateCounters();
    initReveal();
    initButtonGroups();
    initForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
